var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrid = function SvgGrid(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CD3C7894-5A46-41A0-91E0-77B0D5D1DBCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-130.000000, -947.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-grid",
    transform: "translate(130.000000, 947.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.997 C10.3284271,12.997 11,13.6685729 11,14.497 L11,22.497 C11,23.3254271 10.3284271,23.997 9.5,23.997 L1.5,23.997 C0.671572875,23.997 1.01453063e-16,23.3254271 0,22.497 L0,14.497 C-1.01453063e-16,13.6685729 0.671572875,12.997 1.5,12.997 L9.5,12.997 Z M22.5,12.997 C23.3284271,12.997 24,13.6685729 24,14.497 L24,22.497 C24,23.3254271 23.3284271,23.997 22.5,23.997 L14.5,23.997 C13.6715729,23.997 13,23.3254271 13,22.497 L13,14.497 C13,13.6685729 13.6715729,12.997 14.5,12.997 L22.5,12.997 Z M9.5,-0.003 C10.3284271,-0.003 11,0.668572875 11,1.497 L11,9.497 C11,10.3254271 10.3284271,10.997 9.5,10.997 L1.5,10.997 C0.671572875,10.997 1.01453063e-16,10.3254271 0,9.497 L0,1.497 C-1.01453063e-16,0.668572875 0.671572875,-0.003 1.5,-0.003 L9.5,-0.003 Z M22.5,-0.003 C23.3284271,-0.003 24,0.668572875 24,1.497 L24,9.497 C24,10.3254271 23.3284271,10.997 22.5,10.997 L14.5,10.997 C13.6715729,10.997 13,10.3254271 13,9.497 L13,1.497 C13,0.668572875 13.6715729,-0.003 14.5,-0.003 L22.5,-0.003 Z",
    id: "Combined-Shape"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grid.e50f3cddc17b4947fcb304ad60e7f562.svg";